







import { translateKey } from "../ts/translateKey";
import { defineComponent, computed } from "@vue/composition-api";
import { useUserPrefs } from "@/hooks/useUserPrefs";

export default defineComponent({
	props:{
		text:{
			type:String,
			required:true,
		},
		lang:{
			type:String,
			required:false,
		}
	},
	setup(props){
		const { lang } = useUserPrefs();
		const finalLang = computed(() => props.lang || lang.value);
		const translated = computed(() => {
			return translateKey(props.text, finalLang.value) || props.text;
		});

		return {
			translated
		};
	}
});

